<app-base-template (modal)="openModal(content)"(searchmodal) = "searchModal(scarch_content)"  (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[showSearch]="showSearch"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add User</div>
  </div>
    <div class="modal-body">
      <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
      <div class="form-group">
        <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="clientSelected" (change)="onClientChange($event.target.selectedIndex)">
          <option *ngFor="let client of clients" [value]="client.id">{{client.name}}</option>
        </select>
      </div>

      <div class="form-group">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text radius-0"><i class="fa fa-user fa-fw"></i></div>
          </div>
          <input type="text" class="form-control radius-0 font-13" [(ngModel)]="fullname" placeholder="Personal Name">
        </div>
      </div>
      <div class="form-group">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text radius-0"><i class="fa fa-user fa-fw"></i></div>
          </div>
          <input type="text" class="form-control radius-0 font-13" [(ngModel)]="loginName" placeholder="User Id">
        </div>
      </div>
      <div class="form-group">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text radius-0"><i class="fa fa-phone"></i></div>
          </div>
          <input type="text" class="form-control radius-0 font-13" [(ngModel)]="mobile" placeholder="Mobile Number">
        </div>
      </div>
      <div class="form-group">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text radius-0"><i class="fa fa-envelope-o fa-fw"></i></div>
          </div>
          <input type="text" class="form-control radius-0 font-13" [(ngModel)]="email"
                 placeholder="Email Address">
        </div>
      </div>
      <div class="form-group">
        <textarea class="form-control radius-0 font-13" [(ngModel)]="address" placeholder="Address"></textarea>
      </div>
      <!-- <div class="form-group">
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="password"
               placeholder="Password">
      </div> -->

      <form [formGroup]="passwords">
          <mat-form-field>
          <input matInput class="font-13" placeholder="Password" [(ngModel)]="password" [type]="hides ? 'password' : 'text'" formControlName="password" required>
          <mat-icon matSuffix (click)="hides = !hides">{{hides ? 'visibility_off' : 'visibility'}}</mat-icon>
          <mat-hint *ngIf="!passwordInput1.value">Enter your password</mat-hint>
          </mat-form-field>
    </form>

    </div>
    <div class="modal-footer pad-8">
      <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
      <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
    </div>

</ng-template>


<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>

  </div>
  <div class="modal-body">

      <div class="form-group mar_top">
          <input type="text" class="form-control radius-0 font-13" placeholder=" Enter  Name"
                 [(ngModel)]="userSelected"
                 matInput [formControl]="searchUser"[matAutocomplete]="auto"
                >
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getDetails()">
              <mat-option *ngIf="isLoading" class="is-loading">
                  <mat-spinner diameter="50"></mat-spinner>
              </mat-option>
              <ng-container *ngIf="!isLoading">
                  <mat-option *ngFor="let user of usrs" [value]="user.name">
                    {{ user.name }} 
                  </mat-option>
              </ng-container>
          </mat-autocomplete>
      </div>
      <div class="form-group">
          <input type="text" class="form-control radius-0 font-13" placeholder="Login Name" readonly
                 [(ngModel)]="userName">
      </div>
  </div>
  <div class="modal-footer pad-8">
          <button type="button" class="btn btn-success float-right radius-0" (click)="search()">Search</button>
          <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
  </ng-template>



  <ng-template #content1 let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
      <div class="modal-title">Reset Password</div>
  
    </div>
    <div class="modal-body">
        <!-- <div class="note">
            <p class="p">Please Note The Following Password Requirement:</p>
            <ul class="a">
                <li>Must be a minimum of 8 characters and a maximum of 20 characters.</li>
                <li>Must contain a mix of uppercase and lowercase letters.</li>
                <li>Must contain at least one number or non-alphanumeric symbol (eg.!?&).</li>
                <li>Cannot contain any spaces.</li>

            </ul>

        </div>
 -->

        <form [formGroup]="signin">
            <mat-form-field>
            <input matInput class="font-13" placeholder="Password" [(ngModel)]="cPassword" [type]="hide ? 'password' : 'text'" formControlName="password" required>
            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            <mat-hint *ngIf="!passwordInput.value">Enter your password</mat-hint>
            </mat-form-field>
      </form>
      <div class="form-group">

          <input type="password" class="form-control font-13" [(ngModel)]="confirmpassword" placeholder="Confirm Password">

        </div>



            

  
        <!-- <div class="form-group mar_top">
            <input type="text" class="form-control radius-0 font-13" placeholder=" Enter  Name"
                   [(ngModel)]="userSelected"
                   matInput [formControl]="searchUser"[matAutocomplete]="auto"
                  >
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getDetails()">
                <mat-option *ngIf="isLoading" class="is-loading">
                    <mat-spinner diameter="50"></mat-spinner>
                </mat-option>
                <ng-container *ngIf="!isLoading">
                    <mat-option *ngFor="let user of usrs" [value]="user.name">
                      {{ user.name }} 
                    </mat-option>
                </ng-container>
            </mat-autocomplete>
        </div>
       -->
    </div>
    <div class="modal-footer pad-8">
            <button type="button" class="btn btn-success float-right radius-0" (click)="confirm()">Save</button>
            <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
    </div>
  
    </ng-template>
  
<notifier-container></notifier-container>

